// management

export const managementUnitFilterReport: {
  active: { label: string; key: string }[]
  inactive: { label: string; key: string }[]
  pendingCancellation: { label: string; key: string }[]
  cancelled: { label: string; key: string }[]
} = {
  active: [
    { label: 'Device Id', key: 'unitId' },
    { label: 'Status', key: 'status' },
    // { label: '', key: 'monitoringCentreId' },
    { label: 'Monitoring Centre', key: 'monitoringCentre' },
    // { label: '', key: 'bureauId' },
    { label: 'Bureau', key: 'bureau' },
    // { label: '', key: 'techId' },
    { label: 'Technician', key: 'tech' },
    // { label: '', key: 'productImageUrl' },
    // { label: '', key: 'productId' },
    { label: 'Product', key: 'productName' },
    { label: 'Network', key: 'networkType' },
    { label: 'Account #', key: 'accountNo' },
    { label: 'IMEI', key: 'imei' },
    { label: 'Serial #', key: 'serialNo' },
    { label: 'Site', key: 'siteName' },
    // { label: '', key: 'siteImageUrl' },
    { label: 'Mobile', key: 'mobileNo' },
    { label: 'Sim #', key: 'simNo' },
    { label: 'IP Address', key: 'ipAddress' },
    { label: 'Activated on', key: 'dateLoaded' },
    { label: 'Cancels on', key: 'pendingCancellationDate' },
    // { label: 'Cancellation Date', key: 'cancellationDate' },
    // { label: 'Cancellation Processed', key: 'cancellationProcessed' },
    // { label: 'Is Activated', key: 'isActivated' },
    { label: 'Invoice required', key: 'hardwareToBeInvoiced' }
    // { label: '', key: 'unitActivationRequestID' },
    // { label: '', key: 'orderId' }
  ],
  inactive: [
    { label: 'Unit Id', key: 'unitId' },
    { label: 'Status', key: 'status' },
    // { label: '', key: 'monitoringCentreId' },
    { label: 'Monitoring Centre', key: 'monitoringCentre' },
    // { label: '', key: 'bureauId' },
    { label: 'Bureau', key: 'bureau' },
    // { label: '', key: 'techId' },
    { label: 'Technician', key: 'tech' },
    // { label: '', key: 'productImageUrl' },
    // { label: '', key: 'productId' },
    { label: 'Product', key: 'productName' },
    { label: 'Network', key: 'networkType' },
    { label: 'Account #', key: 'accountNo' },
    { label: 'IMEI', key: 'imei' },
    { label: 'Serial #', key: 'serialNo' },
    { label: 'Site', key: 'siteName' },
    // { label: '', key: 'siteImageUrl' },
    { label: 'Mobile', key: 'mobileNo' },
    { label: 'Sim #', key: 'simNo' },
    { label: 'IP Address', key: 'ipAddress' },
    { label: 'Loaded on', key: 'dateLoaded' },
    // { label: 'Pending Cancellation Date', key: 'pendingCancellationDate' },
    // { label: 'Cancellation Date', key: 'cancellationDate' },
    // { label: 'Cancellation Processed', key: 'cancellationProcessed' },
    // { label: 'Is Activated', key: 'isActivated' },
    { label: 'Invoice required', key: 'hardwareToBeInvoiced' }
  ],
  pendingCancellation: [
    { label: 'Unit Id', key: 'unitId' },
    { label: 'Status', key: 'status' },
    // { label: '', key: 'monitoringCentreId' },
    { label: 'Monitoring Centre', key: 'monitoringCentre' },
    // { label: '', key: 'bureauId' },
    { label: 'Bureau', key: 'bureau' },
    // { label: '', key: 'techId' },
    { label: 'Technician', key: 'tech' },
    // { label: '', key: 'productImageUrl' },
    // { label: '', key: 'productId' },
    { label: 'Product', key: 'productName' },
    { label: 'Network', key: 'networkType' },
    { label: 'Account #', key: 'accountNo' },
    { label: 'IMEI', key: 'imei' },
    { label: 'Serial #', key: 'serialNo' },
    { label: 'Site', key: 'siteName' },
    // { label: '', key: 'siteImageUrl' },
    { label: 'Mobile', key: 'mobileNo' },
    { label: 'Sim #', key: 'simNo' },
    { label: 'IP Address', key: 'ipAddress' },
    { label: 'Activated on', key: 'dateLoaded' },
    { label: 'Cancels on', key: 'pendingCancellationDate' },
    // { label: 'Cancellation Date', key: 'cancellationDate' },
    // { label: 'Cancellation Processed', key: 'cancellationProcessed' },
    // { label: 'Is Activated', key: 'isActivated' },
    { label: 'Invoice required', key: 'hardwareToBeInvoiced' }
  ],
  cancelled: [
    { label: 'Unit Id', key: 'unitId' },
    { label: 'Status', key: 'status' },
    // { label: '', key: 'monitoringCentreId' },
    { label: 'Monitoring Centre', key: 'monitoringCentre' },
    // { label: '', key: 'bureauId' },
    { label: 'Bureau', key: 'bureau' },
    // { label: '', key: 'techId' },
    { label: 'Technician', key: 'tech' },
    // { label: '', key: 'productImageUrl' },
    // { label: '', key: 'productId' },
    { label: 'Product', key: 'productName' },
    { label: 'Network', key: 'networkType' },
    { label: 'Account #', key: 'accountNo' },
    { label: 'IMEI', key: 'imei' },
    { label: 'Serial #', key: 'serialNo' },
    { label: 'Site', key: 'siteName' },
    // { label: '', key: 'siteImageUrl' },
    { label: 'Mobile', key: 'mobileNo' },
    { label: 'Sim #', key: 'simNo' },
    { label: 'IP Address', key: 'ipAddress' },
    { label: 'Activated on', key: 'dateLoaded' },
    // { label: 'Pending Cancellation Date', key: 'pendingCancellationDate' },
    { label: 'Cancelled on', key: 'cancellationDate' },
    { label: 'Processed', key: 'cancellationProcessed' }
    // { label: 'Is Activated', key: 'isActivated' },
    // { label: 'Hardware to be Invoiced', key: 'hardwareToBeInvoiced' }
  ]
}

// management

export const portalUnitFilterReport: {
  active: { label: string; key: string }[]
  inactive: { label: string; key: string }[]
  pendingCancellation: { label: string; key: string }[]
  cancelled: { label: string; key: string }[]
} = {
  active: [
    // { label: 'Unit Id', key: 'unitId' },
    { label: 'Status', key: 'status' },
    // { label: '', key: 'monitoringCentreId' },
    { label: 'Monitoring Centre', key: 'monitoringCentre' },
    // { label: '', key: 'bureauId' },
    { label: 'Bureau', key: 'bureau' },
    // { label: '', key: 'techId' },
    { label: 'Technician', key: 'tech' },
    // { label: '', key: 'productImageUrl' },
    // { label: '', key: 'productId' },
    { label: 'Product', key: 'productName' },
    { label: 'Network', key: 'networkType' },
    { label: 'Account #', key: 'accountNo' },
    { label: 'IMEI', key: 'imei' },
    { label: 'Serial #', key: 'serialNo' },
    { label: 'Site', key: 'siteName' },
    // { label: '', key: 'siteImageUrl' },
    { label: 'Mobile', key: 'mobileNo' },
    // { label: 'Sim #', key: 'simNo' },
    // { label: 'IP Address', key: 'ipAddress' },
    { label: 'Activated on', key: 'dateLoaded' }
    // { label: 'Pending Cancellation Date', key: 'pendingCancellationDate' }
    // { label: 'Cancellation Date', key: 'cancellationDate' },
    // { label: 'Cancellation Processed', key: 'cancellationProcessed' },
    // { label: 'Is Activated', key: 'isActivated' },
    // { label: 'Hardware to be Invoiced', key: 'hardwareToBeInvoiced' }
    // { label: '', key: 'unitActivationRequestID' },
    // { label: '', key: 'orderId' }
  ],
  inactive: [
    // { label: 'Unit Id', key: 'unitId' },
    { label: 'Status', key: 'status' },
    // { label: '', key: 'monitoringCentreId' },
    { label: 'Monitoring Centre', key: 'monitoringCentre' },
    // { label: '', key: 'bureauId' },
    { label: 'Bureau', key: 'bureau' },
    // { label: '', key: 'techId' },
    { label: 'Technician', key: 'tech' },
    // { label: '', key: 'productImageUrl' },
    // { label: '', key: 'productId' },
    { label: 'Product', key: 'productName' },
    { label: 'Network', key: 'networkType' },
    { label: 'Account #', key: 'accountNo' },
    { label: 'IMEI', key: 'imei' },
    { label: 'Serial #', key: 'serialNo' },
    { label: 'Site', key: 'siteName' },
    // { label: '', key: 'siteImageUrl' },
    { label: 'Mobile', key: 'mobileNo' },
    // { label: 'Sim #', key: 'simNo' },
    // { label: 'IP Address', key: 'ipAddress' },
    { label: 'Loaded on', key: 'dateLoaded' }
    // { label: 'Pending Cancellation Date', key: 'pendingCancellationDate' },
    // { label: 'Cancellation Date', key: 'cancellationDate' },
    // { label: 'Cancellation Processed', key: 'cancellationProcessed' },
    // { label: 'Is Activated', key: 'isActivated' },
    // { label: 'Hardware to be Invoiced', key: 'hardwareToBeInvoiced' }
  ],
  pendingCancellation: [
    // { label: 'Unit Id', key: 'unitId' },
    { label: 'Status', key: 'status' },
    // { label: '', key: 'monitoringCentreId' },
    { label: 'Monitoring Centre', key: 'monitoringCentre' },
    // { label: '', key: 'bureauId' },
    { label: 'Bureau', key: 'bureau' },
    // { label: '', key: 'techId' },
    { label: 'Technician', key: 'tech' },
    // { label: '', key: 'productImageUrl' },
    // { label: '', key: 'productId' },
    { label: 'Product', key: 'productName' },
    { label: 'Network', key: 'networkType' },
    { label: 'Account #', key: 'accountNo' },
    { label: 'IMEI', key: 'imei' },
    { label: 'Serial #', key: 'serialNo' },
    { label: 'Site', key: 'siteName' },
    // { label: '', key: 'siteImageUrl' },
    { label: 'Mobile', key: 'mobileNo' },
    // { label: 'Sim #', key: 'simNo' },
    // { label: 'IP Address', key: 'ipAddress' },
    { label: 'Activated on', key: 'dateLoaded' },
    { label: 'Cancels on', key: 'pendingCancellationDate' }
    // { label: 'Cancellation Date', key: 'cancellationDate' },
    // { label: 'Cancellation Processed', key: 'cancellationProcessed' },
    // { label: 'Is Activated', key: 'isActivated' },
    // { label: 'Hardware to be Invoiced', key: 'hardwareToBeInvoiced' }
  ],
  cancelled: [
    // { label: 'Unit Id', key: 'unitId' },
    { label: 'Status', key: 'status' },
    // { label: '', key: 'monitoringCentreId' },
    { label: 'Monitoring Centre', key: 'monitoringCentre' },
    // { label: '', key: 'bureauId' },
    { label: 'Bureau', key: 'bureau' },
    // { label: '', key: 'techId' },
    { label: 'Technician', key: 'tech' },
    // { label: '', key: 'productImageUrl' },
    // { label: '', key: 'productId' },
    { label: 'Product', key: 'productName' },
    { label: 'Network', key: 'networkType' },
    { label: 'Account #', key: 'accountNo' },
    { label: 'IMEI', key: 'imei' },
    { label: 'Serial #', key: 'serialNo' },
    { label: 'Site', key: 'siteName' },
    // { label: '', key: 'siteImageUrl' },
    { label: 'Mobile', key: 'mobileNo' },
    // { label: 'Sim #', key: 'simNo' },
    // { label: 'IP Address', key: 'ipAddress' },
    { label: 'Activated on', key: 'dateLoaded' },
    // { label: 'Pending Cancellation Date', key: 'pendingCancellationDate' },
    { label: 'Cancelled on', key: 'cancellationDate' },
    { label: 'Processed', key: 'cancellationProcessed' }
    // { label: 'Is Activated', key: 'isActivated' },
    // { label: 'Hardware to be Invoiced', key: 'hardwareToBeInvoiced' }
  ]
}
